import React, { lazy, Suspense } from 'react'
import { useShowTemple } from '@fs/zion-permissions'
import { useFeatureFlag } from '@fs/zion-flags'
import useShowArabicExperience from './hooks/useShowArabicExperience'
import DynamicLinksProvider from './DynamicLinksProvider'

const MinFooter = lazy(() => import('./MinFooter'))
const FatFooter = lazy(() => import('./FatFooter'))

// Changes to any version of the footer should be updated on our footer docs
// Footer Documentation: https://icseng.atlassian.net/wiki/spaces/Product/pages/133633618/Footer+Documentation

function Footer({ useFatFooter = false, canSeeTemple, ...props }) {
  const { isOn: showFatFooter } = useFeatureFlag('home_footer_fatfooter')
  const [showTemple] = useShowTemple()
  const effectiveCanSeeTemple = canSeeTemple ?? showTemple
  const showArabicExperience = useShowArabicExperience()

  if (showFatFooter && useFatFooter && !showArabicExperience) {
    return (
      <Suspense fallback="">
        <FatFooter {...props} canSeeTemple={effectiveCanSeeTemple} />
      </Suspense>
    )
  }
  return (
    <Suspense fallback="">
      <MinFooter showArabicExperience={showArabicExperience} {...props} canSeeTemple={effectiveCanSeeTemple} />
    </Suspense>
  )
}

export default function FooterWithProviders(props) {
  return (
    <DynamicLinksProvider>
      <Footer {...props} />
    </DynamicLinksProvider>
  )
}
